import { render, staticRenderFns } from "./InsigniaTable.vue?vue&type=template&id=c2699c36&"
import script from "./InsigniaTable.vue?vue&type=script&lang=js&"
export * from "./InsigniaTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports